// SPA search-backend toggle (#199). A tiny external store: the api client reads
// it synchronously to thread `?backend=` into suggest/products, and React
// components subscribe via `useSearchBackend` so flipping it re-runs the suggest
// effect (Search) and refetches the products query (List) on the SAME query.
// Persisted to localStorage; defaults to 'gcp'. Deleting this file + the Header
// toggle + the api-client/queryKey wiring dismisses the bake-off toggle and
// restores #198's single-backend behaviour.
import { useSyncExternalStore } from 'react';

export type SearchBackendName = 'gcp' | 'algolia';

const STORAGE_KEY = 'stalvi.searchBackend';
const listeners = new Set<() => void>();

function readPersisted(): SearchBackendName {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'algolia' ? 'algolia' : 'gcp';
  } catch {
    return 'gcp';
  }
}

let current: SearchBackendName = readPersisted();

export function getSearchBackend(): SearchBackendName {
  return current;
}

export function setSearchBackend(next: SearchBackendName): void {
  if (next === current) return;
  current = next;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Persistence is best-effort (private mode); the in-memory value still flips.
  }
  for (const notify of listeners) notify();
}

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

export function useSearchBackend(): SearchBackendName {
  return useSyncExternalStore(subscribe, getSearchBackend, getSearchBackend);
}
